import PDFPreview from './pdf-preview'

export default PDFPreview
